import { render } from "./Classifications.vue?vue&type=template&id=62ccfed9&ts=true"
import script from "./Classifications.vue?vue&type=script&lang=ts"
export * from "./Classifications.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__